import { BaseSidebar } from "./BaseSidebar";
import { CustomButton } from "src/components/common/Buttons/CustomButton";
import { parentRoutes } from "src/navigators/routes/ParentRoutes";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "src/redux/redux-store/hooks";

export const ParentChildViewReportSidebar: React.FC = () => {
  const navigate = useNavigate();

  const { selectedChild: stateSelectedChild } = useAppSelector(
    (state) => state.child
  );

  const selectedChild = stateSelectedChild || "";

  const sidebarContent = (
    <>
      {selectedChild && (
        <CustomButton
          onClick={() => navigate(`${parentRoutes.CHILD_VIEW}`)}
          variant="outline"
          size="default"
          className="text-sm font-semibold"
          leftIcon="back"
        >
          Back to Learner View
        </CustomButton>
      )}
    </>
  );
  return <BaseSidebar screenName="Learner View">{sidebarContent}</BaseSidebar>;
};
